import { render, staticRenderFns } from "./CV_detail.vue?vue&type=template&id=42bbface&scoped=true&"
import script from "./CV_detail.vue?vue&type=script&lang=js&"
export * from "./CV_detail.vue?vue&type=script&lang=js&"
import style0 from "./CV_detail.vue?vue&type=style&index=0&id=42bbface&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bbface",
  null
  
)

export default component.exports